import { Launch } from "@models/launch.model.ts";
import { httpRequest } from "../../http.ts";
import { LaunchSerializer } from "@models/serializers/launchSerializer.ts";

export class CommandSetLaunchPopulationSegment {
  async run(
    launchId: number,
    populationSegmentId: number | null,
    explicitNone = false,
  ): Promise<Launch> {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/launches/${launchId}/population-segment/`;

    const response = await httpRequest<any>(url, {
      method: "PATCH",
      // explicit_none only means anything with a null id: the user actively
      // chose "no population" (lookalike / DB-fed) rather than clearing it.
      body: { population_segment_id: populationSegmentId, explicit_none: explicitNone },
    });
    return new LaunchSerializer().deserialize(response);
  }
}
